<template>
    <div v-if="needEmailVerify">
        <button
            v-if="!isValid"
            class="btn w-[7.5rem] rounded-md normal-case my-1 sm:my-0"
            :class="[email===''?'btn-accent bg-gray-75':'gradient-primary']"
            :disabled="email===''"
            @click="validEmail"
        >
            驗證Email
        </button>

        <div
            v-else-if="isValid"
            class="flex my-1"
        >
            <div class="flex items-center">
                <SvgIcon
                    icon-name="valid-email-valid"
                    class="h-5 w-5 mr-1"
                />
            </div>
            <p class="text-green-900 text-sm md:text-base">
                驗證成功
            </p>
        </div>
    </div>
</template>

<script>
import { computed, ref, reactive, toRefs, watch } from 'vue';
import { useStore } from 'vuex';
import { getNeedEmailVerify, postCheck } from '@/apis/ValidEmail';

export default {
    components: {
    },
    props: {
        /** 驗證的電子信箱 */
        email: {
            type: String,
            default: '',
        },
        /** 是否驗證通過 */
        isValid: {
            type: Boolean,
            default: false,
        },
        /** 儲存Email有效性驗證紀錄 */
        saveValidRecord: {
            type: Boolean,
            default: true,
        },
        /** 是否通過email相關檢核，false會Disable components */
        isPassCheck: {
            type: Boolean,
            default: true,
        },
        loadingText: {
            type: String,
            default: 'LOADING...',
        },
        needEmailVerify: {
            type: Boolean,
            default: true,
        },
        propsValidEmail: {
            type: Boolean,
            default: false,
        },
        inPopupBase: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:isValid', 'update:needEmailVerify', 'close', 'update:propsValidEmail'],
    setup(props, { emit }) {
        const store = useStore();
        const data = reactive({
            email: props.email,
            /** 驗證狀態 */
            validState: '',
            popupTitle: '',
            /** 識別碼 */
            identifier: '',
            // 輸入框
            isShowInput: false
        });
        /** 顯示彈窗 */
        const visiblePopup = ref(false);
        /** 輸入驗證碼 */
        const isLoading = ref(false);

        const applId = computed(() => store.state.permissions.userInfo.id);

        /** 初始化Data相關參數 */
        const initData = () => {
            data.email = props.email;
            data.validState = '';
        };

        initData();

        const initIsValid = () => {
            isLoading.value = true;
            data.counting = false;
            postCheck(applId.value, data.email).then(res => {
                if (res.data.exist) {
                    data.validState = '00';
                    emit('update:isValid', true);
                }
            }).finally(() => {
                isLoading.value = false;
            });
        };

        const checkNeedEmailVerify = () => {
            getNeedEmailVerify().then(res => {
                emit('update:needEmailVerify', res.data.flag);
                if (res.data.flag === true) {
                    initIsValid();
                }
            });
        };

        checkNeedEmailVerify();

        // watch(() => props.propsValidEmail, (newV) => {
        //     emit('update:propsValidEmail', newV);
        // }, { immediate: false, deep: true });

        // watch(() => data.validState, (newV) => {
        //     emit('update:isValid', newV === '00');
        // }, { immediate: false, deep: true });

        /**
         * 監聽驗證email
         * 有驗證紀錄:取出資料
         * 無:初始化資料
         */
        watch(() => [props.email, props.isPassCheck], (newA, newB) => {
            if (props.saveValidRecord && props.email !== '' && props.isPassCheck) {
                initData();
            }
        }, { immediate: true, deep: true });

        /**
         * 檢查是否已驗證過電子信箱
         * 1.call 檢查是否已驗證過Api
         * 1-1:已驗證過 validState:00
         * 1-2:未驗證過打開彈窗 visiblePopup:true
         */
        const validEmail = () => {
            emit('update:propsValidEmail', true);
        };

        return {
            ...toRefs(data),
            visiblePopup,
            isLoading,
            validEmail,
            close,
        };
    },
};
</script>
